import { render, staticRenderFns } from "./EditProfilePage.vue?vue&type=template&id=a3b4d8a2&"
import script from "./EditProfilePage.vue?vue&type=script&lang=js&"
export * from "./EditProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./EditProfilePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports